import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'; 
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Remedy2Nearby = () => {
  const navigate = useNavigate();
  
  const [allDoctors, setAllDoctors] = useState([]);
  const [nearbyDoctors, setNearbyDoctors] = useState({});
  const [locationFetched, setLocationFetched] = useState(false);

  // // Fetch all doctors on mount
  // useEffect(() => {
  //   const fetchDoctors = async () => {
  //     const res = await axios.get("/api/doctors"); // replace with your endpoint
  //     setAllDoctors(res.data || []);
  //   };
  //   fetchDoctors();
  // }, []);

  useEffect(() => {
    const fallbackDoctors = [
      {
        _id: '1',
        title: 'Dr. Rohan Mehta - Oncologist',
        brief: 'Expert in cancer diagnosis and treatment',
        latitude: 19.0759,
        longitude: 72.8772,
        image: '1'
      },
      {
        _id: '2',
        title: 'Dr. Anjali Verma - Cardiologist',
        brief: 'Heart care and interventional cardiology specialist',
        latitude: 18.9218,
        longitude: 72.8347,
        image: '2'
      },
      {
        _id: '3',
        title: 'Dr. Suresh Iyer - Neurologist',
        brief: 'Brain, stroke, and epilepsy expert',
        latitude: 19.0988,
        longitude: 72.8260,
        image: '3'
      },
      {
        _id: '4',
        title: 'Dr. Neha Rathi - Orthopedic Surgeon',
        brief: 'Bone, joint, and trauma specialist',
        latitude: 19.1197,
        longitude: 72.8468,
        image: '4'
      },
      {
        _id: '5',
        title: 'Dr. Imran Shaikh - Gastroenterologist',
        brief: 'Digestive health and liver disease expert',
        latitude: 19.0550,
        longitude: 72.8296,
        image: '5'
      },
      {
        _id: '6',
        title: 'Dr. Aparna Desai - Nephrologist',
        brief: 'Kidney specialist & dialysis care',
        latitude: 19.1237,
        longitude: 72.9168,
        image: '6'
      },
      {
        _id: '7',
        title: 'Dr. Amit Kale - Pulmonologist',
        brief: 'Respiratory and lung care expert',
        latitude: 19.2183,
        longitude: 72.9781,
        image: '7'
      },
      {
        _id: '8',
        title: 'Dr. Ritu Sharma - Endocrinologist',
        brief: 'Diabetes, thyroid, and hormone health expert',
        latitude: 19.3919,
        longitude: 72.8397,
        image: '8'
      },
      {
        _id: '9',
        title: 'Dr. Vishal Thomas - Psychiatrist',
        brief: 'Mental health and behavioral therapy',
        latitude: 19.0330,
        longitude: 73.0297,
        image: '9'
      },
      {
        _id: '10',
        title: 'Dr. Sneha Nair - Dermatologist',
        brief: 'Skin, hair, and cosmetic dermatology',
        latitude: 18.7500,
        longitude: 73.4070,
        image: '10'
      },
      {
        _id: '11',
        title: 'Dr. Rajat Kapoor - Urologist',
        brief: 'Kidney, bladder, and male health expert',
        latitude: 19.1481,
        longitude: 72.8370,
        image: '11'
      },
      {
        _id: '12',
        title: 'Dr. Meera Joshi - Pediatrician',
        brief: 'Child health, vaccination & nutrition care',
        latitude: 19.1011,
        longitude: 72.8558,
        image: '12'
      },
      {
        _id: '13',
        title: 'Dr. Alka Bansal - Gynecologist',
        brief: 'Women’s health and pregnancy care',
        latitude: 19.1990,
        longitude: 72.9535,
        image: '13'
      }
    ];
    
  
    const fetchDoctors = async () => {
      try {
        const res = await axios.get("/api/doctors");
        if (res.data && res.data.length > 0) {
          setAllDoctors(res.data);
        } else {
          setAllDoctors(fallbackDoctors);
        }
      } catch (err) {
        setAllDoctors(fallbackDoctors); 
      }
    };
  
    fetchDoctors();
  }, []);

  const getDistanceInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const handleNearbyDoctors = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition((position) => {
      const userLat = position.coords.latitude;
      const userLon = position.coords.longitude;

      const ranges = {
        'Within 2 Km': [],
        'Within 5 Km': [],
        'Within 10 Km': [],
        'Within 25 Km': [],
        'More than 25 Km': []
      };

      allDoctors.forEach(doctor => {
        if (doctor.latitude && doctor.longitude) {
          const distance = getDistanceInKm(userLat, userLon, doctor.latitude, doctor.longitude);
          if (distance <= 2) ranges['Within 2 Km'].push({ ...doctor, distance });
          else if (distance <= 5) ranges['Within 5 Km'].push({ ...doctor, distance });
          else if (distance <= 10) ranges['Within 10 Km'].push({ ...doctor, distance });
          else if (distance <= 25) ranges['Within 25 Km'].push({ ...doctor, distance });
          else ranges['More than 25 Km'].push({ ...doctor, distance });
        }
      });

      setNearbyDoctors(ranges);
      setLocationFetched(true);
    }, (err) => {
      alert("Location access denied or failed");
    });
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4 border-spacing-2 border-t-2 border-white">Doctor's Nearby Me</h2>

      <div className="mb-6">
        <button
          onClick={handleNearbyDoctors}
          className="px-4 py-2 bg-pink-600 text-white rounded-full hover:bg-pink-700"
        >
          Refresh Nearby Doctors
        </button>
      </div>

      {locationFetched && Object.keys(nearbyDoctors).map(range => (
        nearbyDoctors[range].length > 0 && (
          <div key={range} className="mb-8">
            <h3 className="text-xl font-semibold mb-3 text-yellow-200">{range}</h3>
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"> */}
            <div className="flex flex-col">
              {nearbyDoctors[range].map(doctor => (
                <div key={doctor._id} className="bg-white shadow-md p-4 rounded-xl mb-2">
                  <img 
                    src={`/api/downloads/thinktravel/doctors/${doctor.image || '1'}.png`}
                    alt={doctor.title}
                    className="w-full h-40 object-cover rounded"
                  />
                  <h4 className="mt-2 text-lg font-semibold">{doctor.title}</h4>
                  <p className="text-sm text-gray-600">{doctor.brief}</p>
                  <p className="text-sm mt-1 text-gray-500">~{doctor.distance.toFixed(1)} km away</p>
                  <button 
                    onClick={() => navigate(`/doctor/${doctor._id}`)}
                    className="mt-3 px-4 py-2 bg-pink-500 text-white rounded-full text-sm"
                  >
                    View Details
                  </button>
                </div>
              ))}
            </div>
          </div>
        )
      ))}
    </div>
  );
};

export default Remedy2Nearby;
